import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError, switchMap, concatMap, tap } from 'rxjs/operators';
import { LobbyService } from '../../shared/services/lobby.service';
import * as LobbyCheckInPageActions from './actions/lobby-check-in-page.actions';
import * as LobbyAPIActions from './actions/lobby-api.actions';
import { of } from 'rxjs';
import { MessageHubService } from 'src/app/shared/services/message-hub.service';
import * as MessageHubActions from '../../../state/actions/message-hub.actions';
import { LobbyEntryService } from '../../shared/services/lobby-entry.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Console } from 'console';

@Injectable()
export class LobbyCheckInEffects {

    constructor(private actions$: Actions,
                private lobbyService: LobbyService,
                private lobbyEntryService: LobbyEntryService,
                private messageHubService: MessageHubService,
                private toastService: ToastService,
                private translateService: TranslateService) { }

    loadLobbyDetails$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCheckInPageActions.loadLobbyDetails),
                mergeMap(action => this.lobbyService.getLobbyDetails(action.locationId)
                    .pipe(
                        map(lobby => LobbyAPIActions.loadLobbyDetailsSuccess({ lobby })),
                        catchError(error => of(LobbyAPIActions.loadLobbyDetailsFailure({ error })))
                        
                    )
                )
            );
            
    });

    loadLobbyServices$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyCheckInPageActions.loadServices),
            mergeMap(action => this.lobbyService.getServices(action.locationId,action.showInLobby,action.showCategory)
                .pipe(
                    map(services => LobbyAPIActions.loadServicesSuccess({ services })),
                    catchError(error => of(LobbyAPIActions.loadServicesFailure({ error })))
                )
            )
        );
    });

    subscribeToLobbySignInUsers$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCheckInPageActions.loadStaffMembers),
                switchMap(action => {                   
                    this.messageHubService.subscribeToSignInUsersGroup({ TenantId: action.tenantId, LocationId: action.locationId,ShowInLobby:action.showInLobby });
                    return of(MessageHubActions.joinLobbySignInUsersGroupActionComplete());
                }
                )
            );
    });

    addToLobby$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCheckInPageActions.addToLobby),
                concatMap(action =>
                    this.lobbyEntryService.addToLobby(action.lobbyCheckIn)
                        .pipe(
                            map(lobbyEntryId => LobbyAPIActions.addToLobbySuccess({ lobbyEntryId })),
                            tap(() => this.toastService.showSuccess('_Lobby_Visitor_Checked_Successfully_Ts_Text_')),
                            catchError(error => {  
                                const accountNumberIn = action.lobbyCheckIn.AccountNumber ? action.lobbyCheckIn.AccountNumber : '';
                                if(error.includes("object")){
                                    this.toastService.showError('_Lobby_Visitor_Checked_Failed_Ts_Text_');
                                }
                                else{
                                    if(error.includes(accountNumberIn)) {
                                        this.translateService.get('_Account_Number_Field_Text_').subscribe(accountNumberField => {
                                        this.translateService.get('_Requested_Already_Person_In_Lobby_Text_', { value0: accountNumberField }).subscribe(translatedString => {
                                            this.toastService.showError(translatedString);
                                        });
                                    });
                                    return of(LobbyAPIActions.addToLobbyFailure({ error }));
                                    }
                                    else if(error.includes("_Requested_Location_Not_Found_Text_")){
                                        this.translateService.get('_Requested_Location_Not_Found_Text_', {value0: action.lobbyCheckIn.LocationId}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("_Requested_Lobby_Entry_Not_Found_Text_")){
                                        this.translateService.get('_Requested_Lobby_Entry_Not_Found_Text_', {value0: action.lobbyCheckIn.LobbySourceId}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("_Appointment_Id_Not_Found_Lobby_Text_")){
                                        this.translateService.get('_Appointment_Id_Not_Found_Lobby_Text_', {value0: action.lobbyCheckIn.LobbySourceId}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are currently assisting (impersonation)")){
    
                                        this.translateService.get('_Currently_Impersonate_Assisting_Another_Visitor_Text_', {value0: 10}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are currently assisting someone in")){
                                        const locationName = error.split("You are currently assisting someone in")[1].split(".")[0].trim();
                                        this.translateService.get('_Last_User_Currently_Assisting_Someone_Text_', {value0: locationName}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are already signed into")){
                                        const locationName = error.split("You are already signed into")[1].split(".")[0].trim();
                                        this.translateService.get('_Last_User_Already_Signed_In_Text_', {value0: locationName}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are the last user signed in to assist lobby records from the requested")){
                                        const locationName = error.split("You are the last user signed in to assist lobby records from the requested")[1].split("group(s)")[0].trim();
                                        this.translateService.get('_Last_User_Signed_Into_Assist_From_ReqGroup_Text_', {value0: locationName}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    this.toastService.showError(error);
                                }                          
                                
                                return of(LobbyAPIActions.addToLobbyFailure({ error }));
                            })
                        )
                    )
            );
    });
    impersonateInstantAssistLobby$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCheckInPageActions.ImpersonateinstantAssist),
                concatMap(action =>
                    this.lobbyEntryService.impersonateInstantAssist(action.lobbyCheckIn, action.userId)
                        .pipe(
                            map(lobbyEntryId => LobbyAPIActions.impersonateInstantAssistSuccess({ lobbyEntryId:lobbyEntryId,isImpersonateAssist:true,impersonateByName:action.impersonateByName})),
                            catchError(error => {
                                console.log('Impersonate Instant assist failed!');
                                const accountNumberIn = action.lobbyCheckIn.AccountNumber ? action.lobbyCheckIn.AccountNumber : '';
                                if(error.includes("object")){
                                    this.toastService.showError('_Lobby_CheckIn_Instant_Assist_Fail_Text_');
                                }
                                else{
                                        if(error.includes(accountNumberIn)) {
                                        this.translateService.get('_Account_Number_Field_Text_').subscribe(accountNumberField => {
                                        this.translateService.get('_Requested_Already_Person_In_Lobby_Text_', { value0: accountNumberField }).subscribe(translatedString => {
                                            this.toastService.showError(translatedString);
                                        });
                                    });
                                    return of(LobbyAPIActions.addToLobbyFailure({ error }));
                                    }
                                    else if(error.includes("_Requested_Location_Not_Found_Text_")){
                                        this.translateService.get('_Requested_Location_Not_Found_Text_', {value0: action.lobbyCheckIn.LocationId}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("_Requested_Lobby_Entry_Not_Found_Text_")){
                                        this.translateService.get('_Requested_Lobby_Entry_Not_Found_Text_', {value0: action.lobbyCheckIn.LobbySourceId}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("_Appointment_Id_Not_Found_Lobby_Text_")){
                                        this.translateService.get('_Appointment_Id_Not_Found_Lobby_Text_', {value0: action.lobbyCheckIn.LobbySourceId}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are currently assisting (impersonation)")){
    
                                        this.translateService.get('_Currently_Impersonate_Assisting_Another_Visitor_Text_', {value0: 10}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are currently assisting someone in")){
                                        const locationName = error.split("You are currently assisting someone in")[1].split(".")[0].trim();
                                        this.translateService.get('_Last_User_Currently_Assisting_Someone_Text_', {value0: locationName}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are already signed into")){
                                        const locationName = error.split("You are already signed into")[1].split(".")[0].trim();
                                        this.translateService.get('_Last_User_Already_Signed_In_Text_', {value0: locationName}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    else if(error.includes("You are the last user signed in to assist lobby records from the requested")){
                                        const locationName = error.split("You are the last user signed in to assist lobby records from the requested")[1].split("group(s)")[0].trim();
                                        this.translateService.get('_Last_User_Signed_Into_Assist_From_ReqGroup_Text_', {value0: locationName}).subscribe(translatedString => {
                                            error = translatedString;
                                        });
                                    }
                                    this.toastService.showError(error);
                                }                                 
                                return of(LobbyAPIActions.impersonateInstantAssistFailure({ error }));
                            })
                        )
                    )
            );
    });

    instantAssistLobby$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyCheckInPageActions.instantAssist),
                concatMap(action =>
                    this.lobbyEntryService.instantAssist(action.lobbyCheckIn, action.userId)
                        .pipe(
                            map(lobbyEntryId => LobbyAPIActions.instantAssistSuccess({ lobbyEntryId })),
                            catchError(error => {
                               
                                console.log('Instant assist failed!');
                                const accountNumberIn = action.lobbyCheckIn.AccountNumber ? action.lobbyCheckIn.AccountNumber : '';
                                if(accountNumberIn!="" && error.includes(accountNumberIn)) {
                                        this.translateService.get('_Account_Number_Field_Text_').subscribe(accountNumberField => {
                                        this.translateService.get('_Requested_Already_Person_In_Lobby_Text_', { value0: accountNumberField }).subscribe(translatedString => {
                                            this.toastService.showError(translatedString);
                                        });
                                    });
                                    return of(LobbyAPIActions.addToLobbyFailure({ error }));
                                    }
                                else if(error.includes("_Requested_Location_Not_Found_Text_")){
                                    this.translateService.get('_Requested_Location_Not_Found_Text_', {value0: action.lobbyCheckIn.LocationId}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                else if(error.includes("_Requested_Lobby_Entry_Not_Found_Text_")){
                                    this.translateService.get('_Requested_Lobby_Entry_Not_Found_Text_', {value0: action.lobbyCheckIn.LobbySourceId}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                else if(error.includes("_Appointment_Id_Not_Found_Lobby_Text_")){
                                    this.translateService.get('_Appointment_Id_Not_Found_Lobby_Text_', {value0: action.lobbyCheckIn.LobbySourceId}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                else if(error.includes("You are currently assisting (impersonation)")){

                                    this.translateService.get('_Currently_Impersonate_Assisting_Another_Visitor_Text_', {value0: 10}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                else if(error.includes("You are currently assisting someone in")){
                                    const locationName = error.split("You are currently assisting someone in")[1].split(".")[0].trim();
                                    this.translateService.get('_Last_User_Currently_Assisting_Someone_Text_', {value0: locationName}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                else if(error.includes("You are already signed into")){
                                    const locationName = error.split("You are already signed into")[1].split(".")[0].trim();
                                    this.translateService.get('_Last_User_Already_Signed_In_Text_', {value0: locationName}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                else if(error.includes("You are the last user signed in to assist lobby records from the requested")){
                                    const locationName = error.split("You are the last user signed in to assist lobby records from the requested")[1].split("group(s)")[0].trim();
                                    this.translateService.get('_Last_User_Signed_Into_Assist_From_ReqGroup_Text_', {value0: locationName}).subscribe(translatedString => {
                                        error = translatedString;
                                    });
                                }
                                this.toastService.showError(error);
                                return of(LobbyAPIActions.instantAssistFailure({ error }));
                            })
                        )
                    )
            );
    });
   
}
